import API from '../../../../commons/api/api';
import * as actionTypes from '../actions/type';

export const initialState = {
  favorites: [],
  isProcessing: false,
  character: [],
  characterDetail: [],
  isProcessingDetail: false
};

const characterReducers = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CHARACTER_FAVORITE:
      return {
        ...state,
        isProcessing: true,
        type: action.type,
      };
    case actionTypes.GET_CHARACTER_FAVORITE_SUCCESS:
      const { payload } = action;
      return {
        ...state,
        isProcessing: false,
        favorites: payload,
      };

    case actionTypes.GET_CHARACTER_REQUEST:
      return {
        ...state,
        isProcessing: true,
        type: action.type,
      };
    case actionTypes.GET_CHARACTER_SUCCESS:
      // console.log(action.payload,'GET_CHARACTER_SUCCESS');
      let data = [];
      if(Array.isArray(action.payload)){
        data = action.payload;
      }else{
        data =  action.payload.data;
      }
      return {
        ...state,
        isProcessing: false,
        character: data,
        type: action.type,
      };

    case actionTypes.GET_CHARACTER_DETAIL_REQUEST:
      return {
        ...state,
        isProcessingDetail: true,
        type: action.type,
      };
    case actionTypes.GET_CHARACTER_DETAIL_SUCCESS:
      return {
        ...state,
        isProcessingDetail: false,
        characterDetail: action.payload || [],
        type: action.type,
      };
    case actionTypes.RESET_CHARACTER:
      return {
        ...state,
        isProcessingDetail: false,
        character: [],
        type: action.type,
      };
    default:
      return state;
  }
};

export default characterReducers;
